export default "__VITE_ASSET__dd723811__"